import axios from 'axios';

export const workflowContainerEmptyApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-container-empty`,
    headers: {
        'Content-Type': 'application/json'
    }
})